import SystemTopNavigationItem from "../items/SystemTopNavigationItem";
import {kSystemMainNavigationItems} from "../../constants/navigation";

export default function SystemTopBarNavigation({currentTab}) {
    // Used in SystemScreenTopBar to display main
    // navigation items

    // BUILD
    return (
        <div className={"flex justify-start items-center"}>
            {kSystemMainNavigationItems.map((item, index) => (
                <SystemTopNavigationItem key={index}
                                         item={item}
                                         isActive={item.name === currentTab} />
            ))}
        </div>
    );
}